export default __webpack_public_path__ + "static/media/awaiting0F.db3a97d6.svg";